import {
  TimesheetEditorRowActions,
  TimesheetEditorTableCell,
  TimesheetEditorTableRow,
} from "@/features/timesheetFlow/components/TimesheetEditorTable";
import { formatTimesheetHours } from "@/features/timesheetFlow/lib/timesheetTimeSort";
import { formatTimeInputValue } from "@/features/timesheetFlow/lib/timesheetTimeRowUtils";
import type { TimesheetRowRecord } from "@/features/timesheetFlow/timesheetFlowTypes";

const WEEKDAY_ABBR_DE = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"] as const;

function formatDateDisplay(iso: string): string {
  if (!iso) return "—";
  const d = new Date(`${iso}T12:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  const date = d.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  return `${WEEKDAY_ABBR_DE[d.getDay()]} ${date}`;
}

export function TimesheetTimeRowDisplay({
  row,
  showTimeRange,
  onEdit,
  onRemove,
  editDisabled = false,
  editLabel = "Zeitzeile bearbeiten",
}: {
  row: TimesheetRowRecord;
  showTimeRange: boolean;
  onEdit: () => void;
  onRemove: () => void;
  editDisabled?: boolean;
  editLabel?: string;
}) {
  return (
    <TimesheetEditorTableRow>
      <TimesheetEditorTableCell className="min-w-[8rem] font-medium">
        {row.person_name || "—"}
      </TimesheetEditorTableCell>
      <TimesheetEditorTableCell className="whitespace-nowrap text-sm text-label-secondary">
        {formatDateDisplay(row.work_date)}
      </TimesheetEditorTableCell>
      {showTimeRange ? (
        <>
          <TimesheetEditorTableCell className="font-mono text-sm tabular-nums text-label-secondary">
            {formatTimeInputValue(row.time_from) || "—"}
          </TimesheetEditorTableCell>
          <TimesheetEditorTableCell className="font-mono text-sm tabular-nums text-label-secondary">
            {formatTimeInputValue(row.time_to) || "—"}
          </TimesheetEditorTableCell>
        </>
      ) : null}
      <TimesheetEditorTableCell className="text-end font-mono text-sm font-semibold tabular-nums">
        {formatTimesheetHours(row.hours_decimal)}
      </TimesheetEditorTableCell>
      <TimesheetEditorTableCell className="min-w-[8rem] text-sm text-label-secondary">
        <span className="line-clamp-2">{row.comment || "—"}</span>
      </TimesheetEditorTableCell>
      <TimesheetEditorTableCell className="w-[4.75rem]">
        <TimesheetEditorRowActions
          onEdit={onEdit}
          onRemove={onRemove}
          editDisabled={editDisabled}
          editLabel={editLabel}
        />
      </TimesheetEditorTableCell>
    </TimesheetEditorTableRow>
  );
}
